import React, { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import whatsapp from "images/whatsapp.svg";
import emailSvg from "images/email.svg";
import sms from "images/sms.svg";
import fileDownload from "images/fileDownload.svg";
import linkShare from "images/link-share.svg";
import SmallPopup from 'components/popup/small-popup';
import styled from 'styled-components';
import { SuccessButton } from 'components/button';
import { copyTextToClipboard } from '__utils/copy-to-clipboard';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import { propsToJS } from '__utils/immutable-to-js';
import ShareSelector from './share.selector';
import { hideSharePopupAction } from './share.actions';
import { FormErrorMessageSpan } from 'views/common-styled-components';
import { isMintproApp } from '__utils/common-utils';
import useFlashToggler from 'hooks/use-flash-toggler';


const ShareOuterBox = styled.div`
    &.shareFormrBoxCust {
        padding: 20px 18px;
        justify-content: space-around;
        align-items: center;
    }
    &.shareOuterBoxCust {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-around;
        align-items: center;
    }
`;
const ShareItemCont = styled.li`
    cursor: pointer;
    padding: 10px;
    list-style: none;
    // line-height: 40px;
    &.shareItemCust{
        text-align: center;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }
`;
const ShareItemIcon = styled.span`
    display: inline-block;
    border-radius: 5px;
    img {
        width: 35px;
        &.iconImgCust{
            width: 45px;
        }
    }
    &.ShareItemIconWp{
        background-color: #25d366!important;
        padding: 5px;
        height: 36px;
    }
    &.ShareItemIconWpCust{
        padding: 10px;
        height: 45px;
        border-radius: 50%;
    }
`;
const ShareItemText = styled.span`
    padding: 8px 0 0 20px;
    color: #354052;
    position: absolute;
    &.textCust{
        position: relative;
        padding:0;
        top: 10px;
    }
`;

const SendViaButton = styled(SuccessButton)`
    &:disabled {
        background-color: #00a364 !important;
        cursor: not-allowed;
        opacity: .65;
        color: white;
}
`

const Share: React.FC = () => {
    
    const dispatch = useDispatch();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { showSharePopup,shareConfig } = propsToJS(useSelector(ShareSelector));
    const [stage, setStage] = useState<string>('list');
    const { register, handleSubmit, formState } = useForm({mode: 'onChange'});
    const { errors } = formState;
    const flash = useFlashToggler();

    useEffect(() => {
        setStage('list');
    }, [showSharePopup]);

    const getShareTitle = (sharePopupText: string) => {
        if (stage === 'email') return "Email";
        else if (stage === 'sms') return "SMS";
        else if(sharePopupText) return sharePopupText;
        else return "Share Via";
    }
    const onWhatsAppShare = () => {
        if(shareConfig?.customWhatsappShare){
            shareConfig?.customWhatsappShare();
        }else{
            if (isMintproApp()) {
            window.open('whatsapp://send?text=' + shareConfig.message, '_blank');
            } else {
                window.open('https://api.whatsapp.com/send?&text=' + shareConfig.message, '_blank');
            }
        }
        
        // TODO: add mixpanel event
        // if (scope.shareCardConfig.shareType == 'shareMintpack') {
        //     triggerEvent(getAnalyticsConfig('onComplete'), {
        //         agentCode: $rootScope.getAgentCode(),
        //         user: $rootScope.userinfoObject && $rootScope.userinfoObject.user,
        //         mintpackName: scope.shareCardConfig.mintPackDetailsView.goalName,
        //         mintpackId: scope.shareCardConfig.mintPackDetailsView.encryptedMintPackId,
        //     }, 'shareMintpackViaWhatsapp');
        // }
        dispatch(hideSharePopupAction());
    }
    const onEmailShare = (data: any) => {
        shareConfig.shareItemDetails ? 
        shareConfig.onEmailOrSMSShare(data.shareEmailInput,'email',shareConfig.shareItemDetails ) : 
        shareConfig.onEmailOrSMSShare(data.shareEmailInput, 'email');
        // shareConfig.onEmailOrSMSShare(data.shareEmailInput, 'email');
    }
    const onDownloadLink = () => {  
        shareConfig.onFileDownload();
    }
    const onSMSShare = (data: any) => {
        shareConfig.shareItemDetails ? 
        shareConfig.onEmailOrSMSShare(data.shareSmsInput,'mobile',shareConfig.shareItemDetails ) : 
        shareConfig.onEmailOrSMSShare(data.shareSmsInput, 'mobile');
    }
    const onCopyLink = () => {
        copyTextToClipboard(shareConfig.shareUrl);
        // TODO: add mixpanel event
        // if (scope.shareCardConfig.shareType == 'shareMintpack') {
        //     triggerEvent(getAnalyticsConfig('onClick'), {
        //         agentCode: $rootScope.getAgentCode(),
        //         user: $rootScope.userinfoObject && $rootScope.userinfoObject.user,
        //         mintpackName: scope.shareCardConfig.mintPackDetailsView.goalName,
        //         mintpackId: scope.shareCardConfig.mintPackDetailsView.encryptedMintPackId,
        //     }, 'shareMintpackViaCopyLink');
        // }
        dispatch(hideSharePopupAction());
        flash.success('Link copied');
    }
    const getShareContent = () => {
        if (stage === 'email') {
            return (<ShareOuterBox className={ isMobile ? "shareFormBoxCust" : ""}>
                <form name="shareFormEmail" onSubmit={handleSubmit(onEmailShare)} noValidate>
                    <input
                        name='shareEmailInput'
                        type="email"
                        placeholder="Email"
                        ref={register({
                            required: "Please enter email",
                            pattern: {
                                value: /^.+@[^.].*\.[a-z]{2,}$/,
                                message: "Please enter valid email"
                            }
                        })}
                    />
                    {errors.shareEmailInput ? <FormErrorMessageSpan>{errors.shareEmailInput.message}</FormErrorMessageSpan> : null}
                    <SendViaButton type="submit" style={{ marginTop: "10px" }} disabled={ !formState.isValid }>Send Email</SendViaButton>
                </form>
            </ShareOuterBox>)
        } else if (stage === 'sms') {
            return (<ShareOuterBox className={ isMobile ? "shareFormBoxCust" : ""}>
                <form name="shareFormSms" onSubmit={handleSubmit(onSMSShare)} noValidate>
                    <input
                        name='shareSmsInput'
                        type="number"
                        placeholder="Mobile"
                        ref={register({
                            required: "Please enter mobile",
                            minLength: {
                                value: 10,
                                message: "Please enter 10 digits only"
                            },
                            maxLength: {
                                value: 10,
                                message: "Please enter 10 digits only"
                            }
                        })}
                    />
                    {errors.shareSmsInput ? <FormErrorMessageSpan>{errors.shareSmsInput.message}</FormErrorMessageSpan> : null}
                    <SendViaButton type="submit" style={{ marginTop: "10px" }} disabled={ !formState.isValid }>Send SMS</SendViaButton>
                </form>
            </ShareOuterBox>)
        } else {
            return (
            <div>
                { shareConfig?.customHeader }
                <div style={{marginBottom: '8px'}}>{shareConfig?.flashMessage}</div>
                { isMobile && <div className='shareViaText'>Share via</div>}
                <ShareOuterBox className={ isMobile ? "shareOuterBoxCust" : ""}>
                <ShareItemCont className={ isMobile ? "shareItemCust" : ""} onClick={onWhatsAppShare}>
                    <ShareItemIcon className={ isMobile ? "ShareItemIconWp ShareItemIconWpCust" : "ShareItemIconWp"}>
                        <img src={whatsapp} alt="whatsapp" style={{ width: "25px" }} />
                    </ShareItemIcon>
                    <ShareItemText className={ isMobile ? "textCust" : ""}>WhatsApp</ShareItemText>
                </ShareItemCont>
                <ShareItemCont className={ isMobile ? "shareItemCust" : ""} onClick={() => setStage('email')}>
                    <ShareItemIcon>
                        <img src={emailSvg} alt="email" className={ isMobile ? "iconImgCust" : ""} />
                    </ShareItemIcon>
                    <ShareItemText className={ isMobile ? "textCust" : ""}>Email</ShareItemText>
                </ShareItemCont>
                <ShareItemCont className={ isMobile ? "shareItemCust" : ""} onClick={() => setStage('sms')}>
                    <ShareItemIcon>
                        <img src={sms} alt="sms" className={ isMobile ? "iconImgCust" : ""} />
                    </ShareItemIcon>
                    <ShareItemText className={ isMobile ? "textCust" : ""}>SMS</ShareItemText>
                </ShareItemCont>
                {!shareConfig?.hideCopyLink && <ShareItemCont className={ isMobile ? "shareItemCust" : ""} onClick={onCopyLink}>
                    <ShareItemIcon>
                        <img src={linkShare} alt="copy" className={ isMobile ? "iconImgCust" : ""} />
                    </ShareItemIcon>
                    <ShareItemText className={ isMobile ? "textCust" : ""}>Copy Link</ShareItemText>
                </ShareItemCont>}
                {shareConfig?.showDownloadLink && <ShareItemCont className={ isMobile ? "shareItemCust" : ""} onClick={onDownloadLink}>
                    <ShareItemIcon>
                        <img src={fileDownload} alt="download" className={ isMobile ? "iconImgCust" : ""} />
                    </ShareItemIcon>
                    <ShareItemText className={ isMobile ? "textCust" : ""}>Download</ShareItemText>
                </ShareItemCont>}
            </ShareOuterBox>
            </div>
            )
        }
    }
    const onCloseSharePopup = () => {
        dispatch(hideSharePopupAction());
    }
    return (<div>
        {showSharePopup === true ? <SmallPopup title={getShareTitle(shareConfig?.sharePopupText)} onClose={onCloseSharePopup} content={getShareContent()}></SmallPopup> : null}
    </div>)
}
export default Share;
